import { render, staticRenderFns } from "./MuiCheckbox.vue?vue&type=template&id=641cdea9&scoped=true"
import script from "./MuiCheckbox.vue?vue&type=script&lang=js"
export * from "./MuiCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MuiCheckbox.vue?vue&type=style&index=0&id=641cdea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641cdea9",
  null
  
)

export default component.exports